var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBgBeneficiosComplete01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1919,
    height: 644,
    viewBox: "0 0 1919 644",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 644,
    fill: "url(#paint0_linear_2373_79441)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2373_79441",
    x1: -346.784,
    y1: 644,
    x2: 180.948,
    y2: -688.662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0732532,
    stopColor: "#0C3A72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86811,
    stopColor: "#0B6BDD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgBeneficiosComplete01);
export default __webpack_public_path__ + "static/media/bg-beneficios-complete-01.91eeb4da45b7d4b14b52f95f9b16d01a.svg";
export { ForwardRef as ReactComponent };